var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcChangeDown = function SvgIcChangeDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#027AFF",
    d: "M4.153 4.615.701.779A.467.467 0 0 1 1.048 0h6.904c.404 0 .617.479.347.779L4.847 4.615a.467.467 0 0 1-.694 0"
  })));
};
export default SvgIcChangeDown;